import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Badge, Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import { fetchUnreadNotifications, markAllAsRead } from "../../slices/notifications/reducer";
import "./NotificationBell.scss";
import NotificationList from "./NotificationList";

const NotificationBell = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dispatch = useDispatch();
  const { notifications, unreadCount, loading } = useSelector((state) => state.Notifications);

  // Fetch unread notifications on component mount and poll periodically
  useEffect(() => {
    // Fetch immediately on mount
    dispatch(fetchUnreadNotifications());
    
    // Poll for new notifications every 10 seconds
    const interval = setInterval(() => {
      dispatch(fetchUnreadNotifications());
    }, 10000);

    return () => clearInterval(interval);
  }, [dispatch]);

  const toggle = () => setDropdownOpen(!dropdownOpen);

  const handleMarkAllRead = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(markAllAsRead());
  };

  return (
    <Dropdown className="notification-bell-dropdown" isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle tag="button" className="btn btn-link notification-bell-toggle">
        <i className="ri-notification-line"></i>
        {unreadCount > 0 && (
          <Badge color="danger" className="notification-badge">
            {unreadCount > 99 ? "99+" : unreadCount}
          </Badge>
        )}
      </DropdownToggle>
      <DropdownMenu right className="notification-dropdown-menu">
        <div className="notification-panel">
          <div className="notification-header">
            <h6>Notifications</h6>
            {unreadCount > 0 && (
              <button
                onClick={handleMarkAllRead}
                className="btn btn-sm btn-link p-0 text-decoration-none"
                style={{ fontSize: '0.78rem', fontWeight: 600, color: '#7c3aed' }}
              >
                Mark all as read
              </button>
            )}
          </div>

          {loading && (
            <div className="notification-loading">
              <div className="spinner-border spinner-border-sm" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}

          {!loading && notifications.length === 0 && (
            <div className="notification-empty">
              <i className="ri-inbox-line"></i>
              <p>No notifications</p>
            </div>
          )}

          {!loading && notifications.length > 0 && (
            <NotificationList notifications={notifications.slice(0, 5)} isPreview={true} />
          )}

          <div className="notification-footer">
            <a href="/notifications" className="btn btn-sm btn-link">
              View All Notifications
            </a>
          </div>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default NotificationBell;
